<template>
  <section class="menu-custom brdr-bottom-1 brdr-cl-secondary">
    <div class="container main-menu"
         v-if="displayMenu"
    >
      <div class="row between-xs start-xs" v-if="isStorePage || isThankYouPage">
        <div class="col-xs-3  p0">
          <div class="link-wrap">
            <div @click="processPartnerLink('/')" class="links flex no-underline">
              <span class="material-icons">home</span>
              <span class="title-partner" v-if="typeof currentPartner !== 'undefined'" :class="{ 'smallNamePartner' : smallNamePartner }">
                {{ currentPartner.title }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-xs-3  p0">
          <div class=" link-wrap pointer" @click="toggleSearchpanel">
            <div class="flex right-icons no-underline">
              <i class="material-icons">search</i>
              {{ $t('Search') }}
            </div>
          </div>
        </div>
        <div class="col-xs-3 p0">
          <div class=" link-wrap">
            <div @click="processPartnerLink('/departments')"  class="links flex no-underline">
              <img src="../../../../assets/icons/icon-cat.svg" alt="cat" width="22" height="22" fetchpriority="high" loading="eager">
              <span> {{ $t('Departments') }}</span>
            </div>
          </div>
        </div>
        <div class="col-xs-3 p0">
          <div class="last link-wrap">
            <div @click="processPartnerLink('/discounts')" class="links flex no-underline">
              <img src="../../../../assets/icons/icon-sale.svg" alt="sale" width="20" height="20" loading="eager" fetchpriority="high">
              {{ $t('Discounts') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import CurrentPage from 'theme/mixins/currentPage'
  import SearchIconLink from 'theme/components/core/blocks/Header/SearchIcon'
  import SearchIcon from '@vue-storefront/core/compatibility/components/blocks/Header/SearchIcon'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Header',
    components: {
      SearchIconLink
    },
    mixins: [CurrentPage, SearchIcon],
    data () {
      return {
        navVisible: true,
        isScrolling: false,
        scrollTop: 0,
        lastScrollTop: 0,
        navbarHeight: 54,
        smallNamePartner: false
      }
    },
    beforeMount () {
      window.addEventListener('scroll', () => {
        this.isScrolling = true
      }, {passive: true})
      setInterval(() => {
        if (this.isScrolling) {
          this.hasScrolled()
          this.isScrolling = false
        }
      }, 250)
    },
    mounted () {
      if (this.currentPartner) {
        let namePartner = this.currentPartner.title.split(' ');
        if (namePartner.length > 1) {
          namePartner.map(text => {
            if (text.length >= 13) {
              this.smallNamePartner = true
            }
          })
        } else {
          if (namePartner[0].length >= 13) {
            this.smallNamePartner = true
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        currentPartner: 'partners/getCurrentPartner'
      }),
      isThankYouPage () {
        return this.$store.state.checkout.isThankYouPage ? this.$store.state.checkout.isThankYouPage : false
      },
      colsAmount () {
        return this.currentPartner.code !== 'macdonalds' && this.currentPartner.code !== 'biosept_pro' ? 3 : 4
      },
      displayMenu () {
        return this.currentPartner && this.currentPartner.display_mode !== 'food'
      },
      isStorePage () {
        return this.$route.name !== 'my-payment-details' &&
               this.$route.name !== 'checkout-payment-failed' &&
               this.$route.name !== 'checkout' &&
               this.$route.name !== 'about-us' &&
               this.$route.name !== 'contacts' &&
               this.$route.name !== 'umovi-dostavki' &&
               this.$route.name !== 'terms-of-use' &&
               this.$route.name !== 'privacy' &&
               this.$route.name !== 'vacancies' &&
               (this.$route.name !== 'category' && this.currentPartner.display_mode !== 'shop')
      }
    },
    methods: {
      gotoAccount () {
        this.$bus.$emit('modal-toggle', 'modal-signup')
      },
      hasScrolled () {
        this.scrollTop = window.scrollY
        if (this.scrollTop > this.lastScrollTop && this.scrollTop > this.navbarHeight) {
          this.navVisible = false
        } else {
          this.navVisible = true
        }
        this.lastScrollTop = this.scrollTop
      },
      processPartnerLink (page) {
        this.$router.push({ path: `${this.currentPartner.route}${page}`})
      }
    }
  }
</script>
<style scoped lang="scss">
  .smallNamePartner{
    @media (max-width: 400px) {
      font-size: 10px!important;
    }
  }
  .title-partner{
    text-align: center;
  }
  .main-menu{
    .link-wrap{
      border-right: 1px solid #efeff4;
      margin: 10px 0 7px 0;
      &.last{
        border-right:none
      }
    }

    .links,
    .right-icons{
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #111111;
      font-weight: bold;
      cursor: pointer;

      @media (max-width: 768px){
        font-size: 14px;
      }

      img{
        fill: #43b02a;
        margin-bottom: 5px;
      }
      button{
        padding: 0;
      }
    }
  }
  .sails-points{
    .brdr-right-1{
      border-right: 1px solid #ebebeb;
    }
    .link-wrap{
      margin: 10px auto 7px auto;
      &.last{
        border-right:none
      }
    }

    .links,
    .right-icons{
      color: #111111;
      cursor: pointer;
      font-size: 12px;


      img{
        fill: #43b02a;
        margin-bottom: 5px;
      }
      button{
        padding: 0;
      }
    }

    .material-icons{
      width: 25px;
      margin-right: 5px;
      color: #11bb2e;
    }
    .sales-item{
      width: calc(100% - 25px);
    }
  }
</style>
